// Daily background rotation (docs/weekly-background-rotation.md, revised
// 28 Jul 2026: daily, not weekly). The day of the year, mod the size of the
// set, picks the entry in rotation.json. The selected image never changes
// when the user toggles theme, only the mode suffix swaps.
//
// Shared rather than client-only since 2 Aug 2026: the public Crossfire pages
// are server-rendered HTML with no React, and they carry the same picture, so
// the rule that picks it has to be readable from both sides. Everything here
// is pure; the browser-only preload stayed in client/background.ts.
// The import attribute is not decoration: the server is NodeNext ESM, where
// a JSON import without one is an error at compile time and a refusal at run
// time. Vite honours the same syntax on the client.
import rotation from "./rotation.json" with { type: "json" };

export interface RotationEntry {
  week: number;
  name: string;
  slug: string;
  light: string;
  dark: string;
}

const ENTRIES: RotationEntry[] = (rotation as { weeks: RotationEntry[] }).weeks;

export function dayOfYear(date: Date): number {
  const start = Date.UTC(date.getFullYear(), 0, 1);
  const day = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  return Math.floor((day - start) / 86400000) + 1;
}

export interface Background {
  name: string;
  light: string;
  dark: string;
}

export function backgroundFor(date: Date): Background {
  const entry = ENTRIES[(dayOfYear(date) - 1) % ENTRIES.length];
  if (!entry) throw new Error("rotation.json has no entries");
  return {
    name: entry.name,
    light: `/backgrounds/${entry.light}`,
    dark: `/backgrounds/${entry.dark}`,
  };
}
